/**
 * Love Store Paris — Page produit (Phase 2)
 * Galerie, Prime VIP, refresh badge panier header
 */
(function () {
  'use strict';

  var PRIME_VIP_THRESHOLD = 29900; /* centimes */
  var STANDARD_FRANCO_THRESHOLD = 5000; /* centimes — livraison classique FR */

  function parseCountdownEnd(value) {
    if (!value) return NaN;
    var normalized = String(value).trim().replace(' ', 'T');
    if (normalized.indexOf('+') === -1 && normalized.indexOf('Z') === -1) {
      normalized += '+02:00';
    }
    return new Date(normalized).getTime();
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  function setActiveGalleryMedia(gallery, mediaId, fallbackSrc, fallbackAlt) {
    var mainImg = gallery.querySelector('[data-lsp-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-lsp-gallery-thumb]');
    if (!mainImg) return;

    var thumb = mediaId
      ? gallery.querySelector('[data-lsp-gallery-thumb][data-media-id="' + mediaId + '"]')
      : null;
    var src = thumb ? thumb.getAttribute('data-src') : fallbackSrc;
    var alt = thumb ? thumb.getAttribute('data-alt') : fallbackAlt;

    if (!src) return;

    mainImg.src = src;
    if (alt) mainImg.alt = alt;
    if (mediaId) mainImg.setAttribute('data-media-id', String(mediaId));

    thumbs.forEach(function (t) { t.classList.remove('is-active'); });
    if (thumb) {
      thumb.classList.add('is-active');
      var track = gallery.querySelector('[data-lsp-gallery-thumbs]');
      if (track) {
        var thumbLeft = thumb.offsetLeft;
        var thumbRight = thumbLeft + thumb.offsetWidth;
        if (thumbLeft < track.scrollLeft) {
          track.scrollTo({ left: thumbLeft, behavior: 'smooth' });
        } else if (thumbRight > track.scrollLeft + track.clientWidth) {
          track.scrollTo({ left: thumbRight - track.clientWidth, behavior: 'smooth' });
        }
      }
    }
  }

  function findCurrentVariant(picker) {
    var script = picker.querySelector('script[type="application/json"]');
    if (!script) return null;

    var variants;
    try {
      variants = JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }

    var options;
    if (picker.tagName === 'VARIANT-RADIOS') {
      options = Array.from(picker.querySelectorAll('fieldset')).map(function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    } else {
      options = Array.from(picker.querySelectorAll('select')).map(function (select) {
        return select.value;
      });
    }

    if (options.some(function (option) { return option == null; })) return null;

    return variants.find(function (variant) {
      return variant.options.every(function (option, index) {
        return options[index] === option;
      });
    });
  }

  function initGalleryThumbsNav(gallery) {
    var wrap = gallery.querySelector('[data-lsp-gallery-thumbs-wrap]');
    if (!wrap || !wrap.classList.contains('lsp-product-gallery__thumbs-wrap--scrollable')) return;

    var track = wrap.querySelector('[data-lsp-gallery-thumbs]');
    var prevBtn = wrap.querySelector('[data-lsp-gallery-prev]');
    var nextBtn = wrap.querySelector('[data-lsp-gallery-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function updateNav() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft >= maxScroll - 1;

      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
      wrap.classList.toggle('is-at-start', atStart);
      wrap.classList.toggle('is-at-end', atEnd);
    }

    function scrollThumbs(direction) {
      track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
    }

    prevBtn.addEventListener('click', function () {
      scrollThumbs(-1);
    });

    nextBtn.addEventListener('click', function () {
      scrollThumbs(1);
    });

    track.addEventListener('scroll', updateNav, { passive: true });

    track.addEventListener('wheel', function (event) {
      if (window.matchMedia('(min-width: 1024px)').matches && Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
        event.preventDefault();
        track.scrollBy({ left: event.deltaY, behavior: 'auto' });
      }
    }, { passive: false });

    window.addEventListener('resize', updateNav);
    updateNav();
  }

  function initGallery(root) {
    var gallery = root.querySelector('[data-lsp-gallery]');
    if (!gallery) return;

    var mainImg = gallery.querySelector('[data-lsp-gallery-main]');
    if (!mainImg) return;

    initGalleryThumbsNav(gallery);

    gallery.querySelectorAll('[data-lsp-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mediaId = thumb.getAttribute('data-media-id');
        var src = thumb.getAttribute('data-src');
        var alt = thumb.getAttribute('data-alt');
        setActiveGalleryMedia(gallery, mediaId, src, alt);
      });
    });

    root.querySelectorAll('variant-radios, variant-selects').forEach(function (picker) {
      picker.addEventListener('change', function () {
        var variant = findCurrentVariant(picker);
        if (!variant || !variant.featured_media) return;

        var featuredMedia = variant.featured_media;
        var preview = featuredMedia.preview_image;
        setActiveGalleryMedia(
          gallery,
          featuredMedia.id,
          preview && preview.src,
          preview && preview.alt
        );
      });
    });
  }

  function refreshPrimeVip(root) {
    var progressEl = root.querySelector('[data-lsp-prime-vip]');
    if (!progressEl) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = cart.total_price || 0;
        var progress = Math.min(100, (total / PRIME_VIP_THRESHOLD) * 100);
        var remaining = Math.max(0, PRIME_VIP_THRESHOLD - total);
        var isEligible = total >= PRIME_VIP_THRESHOLD;

        var fill = progressEl.querySelector('[data-lsp-prime-fill]');
        var amounts = progressEl.querySelector('[data-lsp-prime-amounts]');
        var message = progressEl.querySelector('[data-lsp-prime-message]');
        var eligible = progressEl.querySelector('[data-lsp-prime-eligible]');

        if (fill) fill.style.width = progress + '%';
        if (amounts) amounts.textContent = formatMoney(total) + ' / ' + formatMoney(PRIME_VIP_THRESHOLD);

        var track = progressEl.querySelector('.lsp-prime-vip__track');
        if (track) track.setAttribute('aria-valuenow', String(Math.min(total, PRIME_VIP_THRESHOLD)));

        if (isEligible) {
          if (message) message.hidden = true;
          if (eligible) eligible.hidden = false;
        } else {
          if (message) {
            message.hidden = false;
            var strong = message.querySelector('[data-lsp-prime-remaining]');
            if (strong) strong.textContent = formatMoney(remaining);
          }
          if (eligible) eligible.hidden = true;
        }
      })
      .catch(function () { /* silencieux */ });
  }

  function refreshStandardFranco(root) {
    var progressEl = root.querySelector('[data-lsp-shipping-franco]');
    if (!progressEl) return;

    var thresholdAttr = progressEl.getAttribute('data-lsp-franco-threshold');
    var threshold = thresholdAttr ? parseInt(thresholdAttr, 10) : STANDARD_FRANCO_THRESHOLD;
    if (!threshold || isNaN(threshold)) threshold = STANDARD_FRANCO_THRESHOLD;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = cart.total_price || 0;
        var progress = Math.min(100, (total / threshold) * 100);
        var remaining = Math.max(0, threshold - total);
        var isEligible = total >= threshold;

        var fill = progressEl.querySelector('[data-lsp-franco-fill]');
        var amounts = progressEl.querySelector('[data-lsp-franco-amounts]');
        var message = progressEl.querySelector('[data-lsp-franco-message]');
        var eligible = progressEl.querySelector('[data-lsp-franco-eligible]');

        if (fill) fill.style.width = progress + '%';
        if (amounts) {
          amounts.textContent = formatMoney(total) + ' / ' + formatMoney(threshold);
        }

        var track = progressEl.querySelector('.lsp-shipping-franco__track');
        if (track) {
          track.setAttribute('aria-valuenow', String(Math.min(total, threshold)));
          track.setAttribute('aria-valuemax', String(threshold));
        }

        if (isEligible) {
          if (message) message.hidden = true;
          if (eligible) eligible.hidden = false;
        } else {
          if (message) message.hidden = false;
          var remainingEl = message && message.querySelector('[data-lsp-franco-remaining]');
          if (remainingEl) remainingEl.textContent = formatMoney(remaining);
          if (eligible) eligible.hidden = true;
        }
      })
      .catch(function () { /* silencieux */ });
  }

  function scrollRecs(section, direction) {
    var track = section.querySelector('[data-lsp-recs-track]');
    if (!track) return;

    var slide = track.querySelector('.lsp-product-recs__slide');
    if (!slide) return;

    var gap = parseFloat(getComputedStyle(track).gap) || 16;
    var amount = slide.offsetWidth + gap;
    track.scrollBy({ left: direction * amount, behavior: 'smooth' });
  }

  function initCountdown(root) {
    var countdown = root.querySelector('[data-lsp-countdown]');
    if (!countdown) return;

    function tick() {
      var end = parseCountdownEnd(countdown.getAttribute('data-countdown-end'));
      if (isNaN(end)) return;
      var now = Date.now();
      var total = Math.max(0, Math.floor((end - now) / 1000));
      var days = Math.floor(total / 86400);
      var hours = Math.floor((total % 86400) / 3600);
      var mins = Math.floor((total % 3600) / 60);
      var secs = total % 60;

      var set = function (key, val) {
        var el = countdown.querySelector('[data-unit="' + key + '"]');
        if (el) el.textContent = String(val).padStart(2, '0');
      };

      set('days', days);
      set('hours', hours);
      set('minutes', mins);
      set('seconds', secs);
    }

    tick();
    setInterval(tick, 1000);
  }

  function hookCartRefresh() {
    var origFetch = window.fetch;
    if (!origFetch || origFetch.__lspPatched) return;

    window.fetch = function () {
      var url = arguments[0];
      var isCartAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;

      return origFetch.apply(this, arguments).then(function (response) {
        if (isCartAdd && response.ok) {
          response.clone().json().then(function (data) {
            if (!data.status) {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              document.dispatchEvent(new CustomEvent('cart:updated'));
              document.querySelectorAll('[data-lsp-product]').forEach(function (el) {
                refreshPrimeVip(el);
                refreshStandardFranco(el);
              });
            }
          }).catch(function () { /* ignore */ });
        }
        return response;
      });
    };
    window.fetch.__lspPatched = true;
  }

  function initProduct(root) {
    if (!root || root.dataset.lspProductInit === 'true') return;
    root.dataset.lspProductInit = 'true';

    initGallery(root);
    refreshPrimeVip(root);
    refreshStandardFranco(root);
    initCountdown(root);
  }

  hookCartRefresh();

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-lsp-product]').forEach(initProduct);
  });

  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-lsp-recs-prev]');
    var next = e.target.closest('[data-lsp-recs-next]');
    if (!prev && !next) return;

    var section = (prev || next).closest('[data-lsp-recs]');
    if (!section) return;

    e.preventDefault();
    scrollRecs(section, prev ? -1 : 1);
  });

  document.querySelectorAll('product-recommendations').forEach(function (el) {
    new MutationObserver(function () {
      if (el.querySelector('[data-lsp-recs-track]')) {
        el.classList.add('product-recommendations--loaded');
      }
    }).observe(el, { childList: true, subtree: true });
  });

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-lsp-product]');
    if (el) initProduct(el);
  });
})();
